import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetCardInfoRequestSchema,
  TGetCardInfoResponseSchema,
} from "./getCardInfo.schema";

export const getCardInfo = (axios: IAxiosInstance) => {
  return async (params: TGetCardInfoRequestSchema) => {
    const { worker_id, deleted } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetCardInfoResponseSchema>
    >(`/api/push-to-card/card-info`, {
      params: {
        worker_id,
        ...(deleted && { deleted }),
      },
    });

    return response.data;
  };
};
